<template>
  <div>
    <el-form ref="form" size="small" :model="formData" :rules="rules">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$l('form_label_handlingMethod') ||'处理方式'" prop="handlingMethod">
            <el-radio-group v-model="formData.handlingMethod">
              <el-radio-button v-if="isStop" label="stop">
                {{ '停止检验' }}
              </el-radio-button>
              <template v-else>
                <el-radio-button label="concession">{{
                  $l('form_label_concession') || '申请让步接受'
                }}</el-radio-button>
                <el-radio-button label="return">{{ $l('form_label_return') || '申请退货' }}</el-radio-button>
              </template>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="formData.handlingMethod === 'concession'">
        <el-col :span="24">
          <el-form-item :label="$l('form_label_reason') ||'申请理由'" prop="reason">
            <el-input
              v-model="formData.reason"
              :placeholder="$l('form_placeholder_reason') ||'请选择申请理由'"
              clearable
              readonly
            >
              <el-button
                type="warning"
                slot="append"
                @click="issuesVisible = true"
                >{{ $l('form_btn_select_reason') || '选择申请理由' }}</el-button
              ></el-input
            >
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$l('form_label_applicationRemark') ||'备注说明'" prop="applicationRemark">
            <el-input
              v-model="formData.applicationRemark"
              type="textarea"
              :rows="4"
              :placeholder="$l('form_placeholder_applicationRemark') ||'请输入备注说明'"
              maxlength="500"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <AddIssues
      ref="addIssues"
      v-if="issuesVisible"
      :visible.sync="issuesVisible"
      :issueType="'C'"
      :selectedData="selectedData"
      :title="$l('form_title_select_reason') ||'申请让步理由'"
      @confirm="confirm"
    />
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import AddIssues from '@/views/factory/quality/fabricInspectionReport/components/edit-form/edit-inspection-info/components/add-issues'

export default {
  mixins: [EditLoading],
  components: { AddIssues },
  props: {
    inspectionCode: { type: String, default: '' },
    isStop: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {
        handlingMethod: 'concession',
        reason: '',
      },
      backDialogVisible: false,
      issuesVisible: false,
      concessionList: [],
      selectedData: [],
    }
  },
  watch: {
    isStop: {
      immediate: true,
      handler() {
        this.resetFormData()
      },
    },
  },
  computed: {
    rules() {
      return {
        handlingMethod: [
          {
            required: true,
            message: this.$l('form_tips_select_handlingMethod') || '请选择处理方式',
            trigger: 'blur',
          },
        ],
        reason: [
          {
            required: true,
            message: this.$l('form_tips_select_reason') || '请选择申请理由',
            trigger: ['change', 'blur'],
          },
        ],
      }
    },
  },
  methods: {
    resetFormData() {
      this.formData = {
        ...this.formData,
        handlingMethod: this.isStop ? 'stop' : 'concession',
        reason: this.isStop ? '停止检验' : '',
      }
      this.concessionList = []
      this.selectedData = []
      this.issuesVisible = false
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      const { handlingMethod } = this.formData
      const textMap = {
        concession: '<span style="color: #409eff;">【申请让步接受】</span>',
        return: '<span style="color: #ff4949;">【申请退货】</span>',
        stop: '<span style="color: #ff4949;">【停止检验】</span>',
      }
      const text = textMap[handlingMethod] || ''
      this.$confirm(
        '<p>面料检验不合格，处理方式为：' +
          text +
          '</p><p>是否正式提交面料检验报告</p>',
        '提交确认',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确认',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
          closeOnClickModal: false,
          distinguishCancelAndClose: true,
        }
      ).then(async () => {
        await this.submitApi({
          submitType: handlingMethod,
          data: this.formData,
          concessionList:
            handlingMethod === 'concession' ? this.concessionList : [],
        })
        this.close()
      })
    },

    async submitApi({ submitType, data, concessionList }) {
      if (this.loadingOpen()) return
      const res = await this.$api
        .fabricInspectionSubmitApi({
          submitType,
          ...data,
          concessionList,
          inspectionCode: this.inspectionCode,
        })
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_operate_no') || '操作失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
        type: 'success',
      })
    },

    close() {
      this.$emit('close')
    },
    async confirm(items) {
      if (!items?.length) return

      this.concessionList = [...items]
      this.formData.reason = this.concessionList
        .map((item) => item.defectIssuesTitle)
        .join('、')
      this.selectedData = this.concessionList.map(
        (item) => item.defectIssuesCode
      )
      this.issuesVisible = false
      this.$refs.form.clearValidate('reason')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
